module.exports = __webpack_public_path__ + "img/culturalfit.55fd0970.png";